"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaultDepositInfo = void 0;
class VaultDepositInfo {
    /** @internal */
    constructor(vaultTokenBalances = {}, vaultDeposits = {}, currVaults = []) {
        this.vaultTokenBalances = vaultTokenBalances;
        this.vaultDeposits = vaultDeposits;
        this.currVaults = currVaults;
    }
    get isEmpty() {
        return Object.keys(this.vaultTokenBalances) !== [] && Object.keys(this.vaultDeposits) !== [];
    }
    /**
     * Compare to another instance of `VaultDepositInfo`.
     */
    equals(that) {
        const equals = (a, b) => a.length === b.length &&
            a.every((v, i) => v === b[i]);
        const equalsTM = (a, b) => Object.keys(a).length + 2 === Object.keys(b).length &&
            Object.keys(a).every((v) => a[v].eq(b[v]));
        return (equalsTM(this.vaultTokenBalances, that.vaultTokenBalances) &&
            equalsTM(this.vaultTokenBalances, that.vaultTokenBalances) &&
            equals(this.currVaults, that.currVaults));
    }
}
exports.VaultDepositInfo = VaultDepositInfo;
//# sourceMappingURL=VaultDepositInfo.js.map